import { ROBOTDATA_DETAILS, CLEAR_REDUX } from "../actionTypes";

const initialState = {
    BatteryVoltage: '0',
    SpeedMeasure: 0.00,
    Signal: 'Not Connected',
    NetworkState: undefined,
    Orientation: 0,
    Cord: []
}

export const robotDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ROBOTDATA_DETAILS:
            const { payload } = action
            return {
                ...state,
                BatteryVoltage: payload.battery,
                SpeedMeasure: payload.speed,
                Signal: payload.signal_level,
                NetworkState: payload.network_state,
                Orientation: payload.orientation,
                Cord: [payload.longitude, payload.latitude]
            }
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}